import * as React from "react"
import {Fragment} from "react"
import {Link as RouterLink} from "react-router-dom";
import {Box, Grid, Link, Typography} from "@mui/material";
import {MinimalLayoutWrapperPage as PageWrapper} from "@ui-seeker/app"

import {HOME_ROUTES} from "@constants";
import {useRoutesApp} from "@hooks";
import {CardSeeker, IconSeeker} from "@ui-seeker/core";


const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    height: 1,
    justifyContent: 'space-evenly'
}

const contentStyles = {
    height: .86,
    backgroundImage: "url('/images/dipi_waves.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display:'flex',
    justifyContent:'center',
    alignItems: 'center'
}

export default function HomePage() {
    const { routesApp } = useRoutesApp()

    const props = {
        head: `DIP Insight | ${HOME_ROUTES.TITLE}`,
        title: HOME_ROUTES.TITLE,
        isEmpty: false
    }

    return <PageWrapper {...props}>
        <Box sx={containerStyles}>
            <Grid container sx={contentStyles}>
                <Grid container item xs={7} spacing={2} direction="row" justifyContent="center" alignItems="center">
                    {routesApp.slice(1).map(({ path, title, icon, description, hideInHome=false }) => <Fragment key={path}>
                        { !hideInHome && <Grid item xs={4}>
                            <Link component={RouterLink} to={path} sx={{ textDecoration: 'none'}}>
                                <CardSeeker title={<Box sx={{ fontSize: 20, textWrap: 'nowrap' }}>
                                    <IconSeeker icon={icon} color="primary.main" /> {title}
                                </Box>} contentProps={{ sx: { pt: 1 } }} sx={{ height: 210 }}>
                                    <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500, fontSize:15 }}>
                                        {description}
                                    </Typography>
                                </CardSeeker>
                            </Link>
                        </Grid> }
                    </Fragment>)}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Typography variant="caption" sx={{ fontStyle: 'italic', color: 'text.disabled', fontSize: 14 }}>
                        360º Digital Intelligence Platform. Analyze the entire catalog, content and prices of any brand, retailer or marketplaces
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    </PageWrapper>
}